import { inject, Injectable } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { ContentUnitForm } from '@features/content-unit/models/content-unit.model'
import { GlobalErrorService } from '@services/global-error.service'
import { ContentUnitService } from '@features/content-unit/services/content-unit.service'
import { contentUnitExistsValidator } from '@features/content-unit/validators/content-unit-exists.validator'
import { richTextRequiredValidator } from '@features/content-unit/validators/rich-text-required.validator'

@Injectable({ providedIn: 'root' })
export class ContentUnitFormService {
  private readonly fb = inject(FormBuilder)
  private readonly globalErrorService = inject(GlobalErrorService)
  private readonly apiService = inject(ContentUnitService)

  public buildForm(): FormGroup<ContentUnitForm> {
    return this.fb.group({
      uuid: [null],
      title: new FormControl<string | null>('', { validators: [Validators.required] }),
      description: new FormControl<string | null>(''),
      tags: new FormControl<string[] | null>([]),
      content: new FormControl<string | null>('', { validators: [richTextRequiredValidator()] }),
      skipPlaceholder: new FormControl<boolean | null>(false)
    }) as FormGroup<ContentUnitForm>
  }

  public addAsyncValidators(form: FormGroup<ContentUnitForm>, initialTitle?: string): void {
    const control = form.controls.title
    control.setAsyncValidators([contentUnitExistsValidator(this.apiService, this.globalErrorService, initialTitle)])
    control.updateValueAndValidity({ emitEvent: false })
  }
}
